import { http } from "api/apiConfig";
import { DEVICE_POLL_URL, GET_DEVICES_FOR_PROVISIONING, SEND_PROVISIONING_COMMAND, } from "constants/endpoints";
export const fetchDpads = async (customerId) => {
    const { data } = await http.get(GET_DEVICES_FOR_PROVISIONING(customerId));
    return data;
};
export const sendProvisioningCommand = async ({ deviceId, command, }) => {
    const { data } = await http.post(SEND_PROVISIONING_COMMAND(deviceId), {
        command,
    });
    return data;
};
export const fetchHealthCheck = async (pollUrl) => {
    const { data } = await http.get(DEVICE_POLL_URL(pollUrl));
    return data;
};
